export function setupHelpers () {
	/* #### Global Helpers #### */
	window.helpers = {}
	/* ## Core JS ## */
	// note: lodash _.clonedeep is better but is also a 20mb import by itself.  yikes.
	// window.helpers.deepClone = require('lodash.clonedeep');
	// eslint-disable-next-line
	window.helpers.deepClone = (src) => { let target = {}; for (let prop in src) { if (src.hasOwnProperty(prop)) { target[prop] = src[prop]; } } return target; }
	window.helpers.empty = (data) => {
		if (typeof(data) == 'number' || typeof(data) == 'boolean') { return false; }
		if (typeof(data) == 'undefined' || data === null) { return true; }
		if (typeof(data.length) != 'undefined') { return data.length == 0; }
		let count = 0;
		for(var i in data) { if(data.hasOwnProperty(i)) { count ++; } }
		return count == 0;
	}
	window.helpers.isFunction = (checkThis) => { if (typeof checkThis !== 'undefined') { return checkThis && {}.toString.call(checkThis) === '[object Function]'; } }
	window.helpers.formatMoney = function (number ,c = 2, d = '.', t = ',', p = '$') {
		let n = number
		c = isNaN(c = Math.abs(c)) ? 2 : c
		let s = n < 0 ? '-' : ''
		let i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(2)))
		let j = (j = i.length) > 3 ? j % 3 : 0
		return s + p + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')
	};
	/* ## App Helpers ## */
	window.helpers.clickTriggerKeyboard = (elementId) => { const el = document.getElementById(elementId); if (el) { el.value = ''; el.focus(); el.click(); } }
	window.helpers.clickTriggerKeyboardAndClear = (elementId) => { const el = document.getElementById(elementId); if (el) { el.value = ''; el.focus(); el.click(); } }
	window.helpers.clickTriggerScan = window.helpers.clickTriggerKeyboard
	window.helpers.callbackAfterScan = () => {}
	window.helpers.resetScanCallback = () => { window.helpers.callbackAfterScan = () => {} }
	window.helpers.setCallback = (callbackFunction) => { if (window.helpers.isFunction(callbackFunction)) { window.helpers.callbackAfterScan = callbackFunction } }
	window.helpers.doCallback = () => { window.helpers.callbackAfterScan(); window.helpers.resetScanCallback(); }
	window.helpers.attachCallbackOnEnter = (elementId) => { const el = document.getElementById(elementId); if (el) { el.addEventListener("keyup", function(event) { event.preventDefault(); if (event.keyCode === 13) { window.helpers.doCallback() } }); } }
	window.helpers.detachCallbackOnEnter = (elementId) => { const el = document.getElementById(elementId); if (el) { el.removeEventListener("keyup", function(event) { event.preventDefault(); if (event.keyCode === 13) { window.helpers.doCallback() } }); } }
	window.helpers.attachCallbackOnClick = (elementId) => { const el = document.getElementById(elementId); if (el) { el.addEventListener("click", function(event) { event.preventDefault(); window.helpers.doCallback() }); } }
	window.helpers.detachCallbackOnClick = (elementId) => { const el = document.getElementById(elementId); if (el) { el.removeEventListener("click", function(event) { event.preventDefault(); window.helpers.doCallback() }); } }
	/* ## Requests ## */
	window.params = new URLSearchParams(window.location.search)
	/* ## Debugging ## */
	// eslint-disable-next-line
	window.debug = (debug_output) => { if (window.scanner.debugging) { console.log(debug_output); } }
}